import React, { useEffect, useState } from "react";
import { Button, Table, Space, Tooltip, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { EyeOutlined } from "@ant-design/icons";

const { Option } = Select;

const ListCompanyEquipContainingLog = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState("all");

  const [shipList, setShipList] = useState([]);
  const [shipId, setShipId] = useState("");

  const fetchShipTableList = async () => {
    const res = await post(ApiURL.list_ships_view_com, new FormData());
    if (res?.status && res.ships?.length) {
      setShipList(res.ships);
      setShipId(res.ships[0].id);
    }
  };

  const LIST_API = async (selectedFilter = filter, selectedShip = shipId) => {
    if (!selectedShip) return;
    setLoading(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("ship_id", selectedShip);

    if (selectedFilter !== "all") {
      FORM_DATA.append("filter", selectedFilter);
    }

    const res = await post(ApiURL.company_list_ods_record, FORM_DATA);
    setData(res?.status ? res?.data || [] : []);
    setLoading(false);
  };

  useEffect(() => {
    fetchShipTableList();
  }, []);

  useEffect(() => {
    if (shipId) LIST_API();
  }, [shipId]);

  const handleFilterChange = (value) => {
    setFilter(value);
    LIST_API(value, shipId);
  };

  const columns = [
    { title: "Equipment", dataIndex: "equipment", align: "center" },
    { title: "Location on Board", dataIndex: "location_on_board", align: "center" },
    { title: "Year of Installation", dataIndex: "year_of_installation", align: "center" },
    { title: "Refrigerant Type", dataIndex: "refrigerant_type", align: "center" },
    {
      title: "Action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="View Record">
          <EyeOutlined
            style={{ fontSize: 18, color: "#1677ff", cursor: "pointer" }}
            onClick={() =>
              navigate(`/view-equip-containing-log/${record?.ods_id}`)
            }
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h2>Equip Containing Log</h2>

        <Space>
          <Select
            value={shipId}
            style={{ width: 220 }}
            onChange={(value) => {
              setShipId(value);
              LIST_API(filter, value);
            }}
          >
            {shipList.map((ship) => (
              <Option key={ship.id} value={ship.id}>
                {ship.vessel_name}
              </Option>
            ))}
          </Select>

          <Button type={filter === "all" ? "primary" : "default"} onClick={() => handleFilterChange("all")}>
            All
          </Button>
          <Button type={filter === "pending" ? "primary" : "default"} onClick={() => handleFilterChange("pending")}>
            Pending
          </Button>
          <Button type={filter === "approved" ? "primary" : "default"} onClick={() => handleFilterChange("approved")}>
            Approved
          </Button>

        </Space>
      </div>

      <Table
        bordered
        loading={loading}
        columns={columns}
        dataSource={data}
        rowKey="ods_id"
        className="custom-table"
      />
    </>
  );
};

export default ListCompanyEquipContainingLog;
